import { useQuery } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import customInstance from '@/api/mutator';
import { queryKeys } from '@/config/query/queryKeys';

interface IntercomTokenResponse {
  token: string;
}

const THIRTY_MINUTES = 30 * 60 * 1000;

async function fetchIntercomToken(): Promise<string> {
  const response = await customInstance<IntercomTokenResponse>({
    method: 'GET',
    url: ENDPOINTS.USER.INTERCOM,
  });
  return response.token;
}

export function useIntercomToken(enabled: boolean) {
  return useQuery<string>({
    enabled,
    queryFn: fetchIntercomToken,
    queryKey: queryKeys.user.intercomToken(),
    staleTime: THIRTY_MINUTES,
  });
}
